<template>
  <div class="image" data-state="waiting">
    <figure>
      <div class="image__cut image__cut--left">
        <img class="image__img" :src="switchImg" :alt="data.alt">
      </div>
      <div class="image__cut image__cut--right">
        <img class="image__img" :src="switchImg" :alt="data.alt">
      </div>
    </figure>
    <h3 class="city-footer__title"
      data-mouse
      data-mouse-attractionState="disactive"
      data-hover-type="fadeout"
      :data-hover="data.nameNext"
    >{{ data.nameNext }}</h3>
  </div>
</template>

<script>
import gsap from 'gsap';

require('intersection-observer');

export default {
  name: 'CityFooterImage',

  props: ['data'],

  computed: {
    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.data.url}.webp`;
      }
      return `${this.data.url}.jpg`;
    },
  },

  mounted() {
    gsap.set('.image__cut', { webkitClipPath: 'inset(0.01% 100% 0.03% 0.04%)' });
    gsap.set('.image__img', { scale: 1.3 });

    const intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      this.enter(this.$el);

      intersectionObserver.disconnect();
    });

    intersectionObserver.observe(this.$el);
  },

  methods: {
    enter(el) {
      const tl = new gsap.TimelineMax({ onComplete: () => {
        el.setAttribute('data-state', 'entered');
      } });

      tl.add('start')
        .staggerFromTo('.image__cut', 0.8, {
          webkitClipPath: 'inset(0.01% 100% 0.03% 0.04%)',
        }, {
          webkitClipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
          clearProps: 'all',
          ease: gsap.Expo.easeOut,
          delay: 0.5,
        }, 0.03, 'start')
        .staggerFromTo('.image__img', 1.6, {
          scale: 1.3,
        }, {
          scale: 1,
          clearProps: 'all',
          ease: gsap.Expo.easeOut,
          delay: 0.5,
        }, 0.03, 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../styles/mixins';
@import '../application';

.image {
  position: relative;
  width: 100%;
  margin-top: 80px;
  max-height: 460px;
  pointer-events: none;

  z-index: 2;

  @include aspect-ratio(16, 9);

  figure {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    margin: 0;
    padding: 0;
  }

  .image__cut {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;

    overflow: hidden;

    img {
      display: block;
      position: absolute;
      width: 200%;
      max-height: 584px;

      @include boost-performance(false);
    }

    &--left {
      transform: translate3d(0, -10px, 0);

      @include mq(sm) {
        transform: translate3d(0, -20px, 0);
      }

      img {
        left: 0;
      }
    }

    &--right {
      transform: translate3d(100%, 10px, 0);

      @include mq(sm) {
        transform: translate3d(100%, 20px, 0);
      }

      img {
        right: 0;
      }
    }
  }

  .city-footer__title {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0;

    font-size: 2.5em;
    -webkit-text-stroke: 2px $color-blue;
    color: transparent;

    transform: translateX(-50%) translateY(-50%) rotate(-6deg);
    z-index: 10;
    backface-visibility: hidden;
    pointer-events: all;

    @include mq(sm) {
      font-size: 4em;
    }

    &::before {
      content: attr(data-hover);

      position: absolute;
      width: 0%;
      top: 0;
      left: 0;

      overflow: hidden;
      white-space: nowrap;
      color: $color-blue;

      transition: width 0.5s cubic-bezier(.17,.67,.32,.87);
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover .city-footer__title::before,
  .no-pointerevents.no-touchevents &:hover .city-footer__title::before {
    width: 100%;
    transition: width 0.5s cubic-bezier(.17,.67,.32,.87);
  }
}

.image[data-state="entered"] {
  pointer-events: all;

  .image__cut {
    transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);

    &--left img,
    &--right img {
      transition: all 1s cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: scale(1);
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover .image__cut--left,
  .no-pointerevents.no-touchevents &:hover .image__cut--left {
    transform: translate3d(0, 0, 0);
  }

  @at-root .pointerevents:not(.touchevents) &:hover .image__cut--right,
  .no-pointerevents.no-touchevents &:hover .image__cut--right {
    transform: translate3d(100%, 0, 0);
  }

  @at-root .pointerevents:not(.touchevents) &:hover .image__cut img,
  .no-pointerevents.no-touchevents &:hover .image__cut img {
    transition: all 8s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: scale(1.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CityFooterImage.vue